import { OrganisationTypes, mutuallyExclusiveOrganisationTypesArray } from '@percent/domain/verifications'

export const filterMutuallyExclusiveOrganisationTypes = (
  submittedOrganisationTypesArray: OrganisationTypes[],
  mergeRelationshipOrgaisationTypes: OrganisationTypes[]
) => {
  const uniqueConcatSubmitedOrganisationTypesArray = Array.from(
    new Set([...submittedOrganisationTypesArray, ...mergeRelationshipOrgaisationTypes])
  )

  const firstExclusiveIndex = uniqueConcatSubmitedOrganisationTypesArray.findIndex(orgType =>
    mutuallyExclusiveOrganisationTypesArray.includes(orgType)
  )

  // Include only non-exclusive options + the first found exclusive option
  return uniqueConcatSubmitedOrganisationTypesArray.filter(
    (orgType, index) => !mutuallyExclusiveOrganisationTypesArray.includes(orgType) || index === firstExclusiveIndex
  )
}
